import * as types from './loadingActionTypes';

export const setLoadingAction = (payload) => {
  return {
    type: types.SET_LOADING,
    payload,
  };
};

export const setLoadingFullAction = (payload) => {
  return {
    type: types.LOADING_FULL,
    payload,
  };
};
